


















import { Component, Mixins } from 'vue-property-decorator';
import AddressEditor from '@/components/registration/common/AddressEditor.vue';
import FieldMixin from '@/mixins/registration/FieldMixin';
import RegistrationPanelMixing from '@/mixins/registration/RegistrationPanelMixin';
import lodash from 'lodash';
import { AddressInfoModel } from '@/interfaces/registration/models/AddressInfoModel';

@Component({
  components: { AddressEditor }
})

export default class AddressPanel extends Mixins(FieldMixin, RegistrationPanelMixing) {
  public model: AddressInfoModel = {};

  public isAddressFunctionSelectable (): boolean {
    const field = lodash.find(this.registrationData.formConfig?.fields, { fieldType: 'Address' });
    return field === undefined || field.addressFunctionId === undefined || field.addressFunctionId === 'NotSpecified';
  }

  public customLabel (): string {
    return this.getCustomLabel('Address') || 'Address';
  }

  mounted () {
    this.$data.model = this.getPanelData('addressInfo');

    window.scrollTo(0, 0);
  }

  public savePanelData (): Promise<boolean> {
    this.saveRegistrationModel({ data: this.model, model: 'addressInfo' });
    return Promise.resolve(true);
  }
}
